import React, { Component } from "react"
import { Input, Icon } from "antd"
import { inject, observer } from "mobx-react"
import cx from "classnames"

const Search = Input.Search

@inject("manager", "auth") @observer
export default class extends Component {
  state = {
    keyword: ""
  }

  updateKeyword = (event) => {
    this.props.manager.currentTask.setSelectedId(undefined)
    this.setState({ keyword: event.target.value })

    if (this.timer) {
      clearTimeout(this.timer)
    }

    const target = event.target
    this.timer = setTimeout(() => {
      this.props.manager.currentTask.searchGroups(target.value)
      clearTimeout(this.timer)
    }, 400)
  }

  addListItem = () => {
    const { keyword } = this.state
    let { groups, addGroupItem } = this.props.manager.currentTask
    if (keyword === "" || groups.some(item => item.groupInfo.name === keyword)) {
      return
    }

    addGroupItem(keyword) // 解构值相当于值传递，包括对象引用
    this.setState({ keyword: "" })
  }

  updateSelected = (group, element) => {
    const { groupInfo } = group
    const { currentTask } = this.props.manager
    const { auth: { pushAuth } } = this.props
    currentTask.updateSelected(groupInfo, pushAuth.verifyLimsPgdFamily)
    this.setState({ keyword: "" })
  }

  componentDidMount() {
    this.props.manager.currentTask.loadGroups()
  }

  /**
   * mobx 存在的一个问题。文件内容长度因为初始值是非 Observable
   * 值，因此在不重新执行 render 的情况下，文件内容长度无法响应
   * 解决方案: 通过引入一个一定变化的值 (filesCount) 来达到主动渲染页面的目的
   */
  render() {
    const { keyword } = this.state

    return (
      <div className="uploadmodal-left-section">
        <div className="search-input-div">
          <Search placeholder="快速筛选/创建分组或家系"
            className="ant-search-input"
            size="large"
            value={keyword}
            onChange={this.updateKeyword} />
        </div>
        <List
          keyword={keyword}
          onAdd={this.addListItem}
          onSelect={this.updateSelected} />
      </div>
    )
  }
}

@inject("manager") @observer
class List extends Component {
  getGroupIndex = (groupName) => {
    let { groups } = this.props.manager.currentTask
    return groups.findIndex(
      group => group.groupInfo.name === groupName
    )
  }

  renderHelperItem = () => {
    const { keyword, onAdd } = this.props

    return (
      <p key={"new-item-" + keyword}
        className="help-item"
        title={keyword}>
        <Icon type="team" className="icon-in-list" />
        <span className="help-title">{keyword}</span>
        <span className="help-creator" onClick={onAdd}>创建</span>
      </p>
    )
  }

  /*
   * 准确说，在初次进入后，同样也是无 keyword + selectedIndex > -1 的条件
   * 但基于 mobx 渲染机制，List 本身不会渲染，因此可以避免在初始列表中点击后的调用
   * 为了保证逻辑的严谨，还是加了 “是否产生搜索结果” 这个判定条件
   */
  componentDidUpdate() {
    const { currentTask: { groups, selectedGroup, searchedGroups } } = this.props.manager

    const selectedIndex = groups.indexOf(selectedGroup)
    if (!this.props.keyword && selectedIndex > -1 && searchedGroups.length > 0) {
      this.adjustScrollDistance()
    }
  }

  adjustScrollDistance = () => {
    const { currentTask: { groups, selectedGroup } } = this.props.manager
    this.refs.groupList.scrollTop = 46 * groups.indexOf(selectedGroup)
  }

  render() {
    const { keyword, onSelect } = this.props
    const { groups, searchedGroups } = this.props.manager.currentTask
    const currentGroups = keyword ? searchedGroups : groups
    const group = currentGroups.find(group => group.groupInfo.name === keyword)

    return (
      <div ref="groupList" className="group-name-list">
        {(!group && keyword) && this.renderHelperItem()}
        {(currentGroups || []).filter(
          group => keyword ? group.groupInfo.name.toLowerCase().indexOf(keyword.toLowerCase()) >= 0 : true
        ).map((group) => {
          return (
            <GroupItem
              key={group.groupInfo.id}
              group={group}
              onClick={() => onSelect(group)} />
          )
        })
        }
      </div>
    )
  }
}

@inject("manager") @observer
class GroupItem extends Component {
  /**
   * selectedGroupIndex 注入 Group 对象即可
   */
  render() {
    const { group, onClick, manager } = this.props
    const { selectedGroupId } = manager.currentTask

    const selected = selectedGroupId === group.groupInfo.id
    return (
      <p key={group.groupInfo.name}
        className={cx({ selected })}
        title={group.groupInfo.name}
        onClick={onClick}>
        <Icon type="team" className="icon-in-list" />
        <span className="group-name">{group.groupInfo.name}</span>
        {group.files.length > 0 &&
          <span className={cx("list-data-count", { selected })}>{group.files.length}</span>
        }
      </p>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/normal/BasicModal/UploadModal/GroupList.js